import { useEffect, useRef, useState } from "react";

const shareOptions = [
  { key: "weibo", label: "分享到微博", icon: "ri-weibo-fill" },
  { key: "wechat", label: "分享给微信好友", icon: "ri-wechat-fill" },
  { key: "moments", label: "分享到朋友圈", icon: "ri-article-line" },
  { key: "link", label: "复制链接", icon: "ri-link" },
];

export default function ShareBar() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [toast, setToast] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  const showToast = (message: string) => {
    setToast(message);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setToast(""), 2600);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制浏览器地址");
    }
  };

  const handleOption = (key: string) => {
    setPanelOpen(false);
    if (key === "link") {
      copyLink();
      return;
    }
    showToast("演示功能：已模拟打开分享渠道（未接入真实平台）");
  };

  return (
    <div className="relative flex items-center gap-2">
      <button
        type="button"
        onClick={copyLink}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <i className="ri-link" />
        复制链接
      </button>
      <button
        type="button"
        onClick={() => setPanelOpen((v) => !v)}
        aria-expanded={panelOpen}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>

      {panelOpen && (
        <>
          <button
            type="button"
            aria-label="关闭分享面板"
            onClick={() => setPanelOpen(false)}
            className="fixed inset-0 z-40 cursor-default bg-transparent"
            tabIndex={-1}
          />
          <div className="absolute right-0 top-12 z-50 w-56 animate-fade-up rounded-lg border border-background-200 bg-background-50 p-2 shadow-lg">
            <p className="px-2 py-1.5 text-xs text-foreground-500">演示分享面板</p>
            {shareOptions.map((option) => (
              <button
                key={option.key}
                type="button"
                onClick={() => handleOption(option.key)}
                className="flex w-full items-center gap-3 rounded-md px-2 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                <i className={`${option.icon} text-base text-primary-600`} />
                {option.label}
              </button>
            ))}
          </div>
        </>
      )}

      {toast && (
        <div className="absolute -bottom-12 right-0 z-50 flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-900 px-3.5 py-2 text-xs font-medium text-background-50 animate-fade-up">
          <i className="ri-information-line" />
          {toast}
        </div>
      )}
    </div>
  );
}